import Divider from '@spotnana/pixel-react/dist/Divider';
import { IUseFareChangeDetailsResult } from 'obt-common';
import { Modal } from '@spotnana/blocks/src/Modal';
import { useTranslation } from 'react-i18next';
import noop from 'lodash/noop';
import PolicyViolations from '../../../../../../v2-components/shared/OutOfPolicyModal/PolicyContent/PolicyViolations';
import { FareChangeNote, PolicyContainer, ViolatonsContainer, fare_change_alert_card } from './styles';
import FareBreakup from './FareBreakup';
import ApprovalMessageContainer from './ApprovalMessageContainer';
import FareRulesChange from './FareRulesChange';

interface IProps {
  confirmCheckout: () => void;
  disabled: boolean;
  toggleConfirmationBox: () => void;
  isLoading: boolean;
  confirmButtonText: string;
  confirmButtonLoadingText?: string;
  onCancel: () => void;
  fareChangeDetails: IUseFareChangeDetailsResult;
  isVoidable?: boolean;
}

const FareChangeAlertModal = ({
  confirmCheckout,
  disabled,
  toggleConfirmationBox,
  isLoading,
  confirmButtonText,
  confirmButtonLoadingText,
  onCancel,
  fareChangeDetails,
  isVoidable,
}: IProps): JSX.Element => {
  const { t: tt } = useTranslation('WEB');

  const { policyInfos } = fareChangeDetails;

  const ruleInfos =
    policyInfos && policyInfos.length
      ? policyInfos[0]?.ruleResultInfos.filter((ruleResultInfo) => ruleResultInfo.violationInfos.length > 0)
      : [];

  const handleConfirmCheckout = (): void => {
    toggleConfirmationBox();

    confirmCheckout();
  };

  const isNewFareOutOfPolicy = ruleInfos.some((rule) => {
    return !!rule.violationInfos[0];
  });

  return (
    <Modal
      open
      contentVariant="multicard"
      /**
       * User should only be able to close modal by clicking on action buttons, not by clicking on the backdrop
       */
      onClose={noop}
      hideCloseButton
      header={{
        title: tt('Fare change alert'),
      }}
      variant="large"
      data-testid="modal_fare-change-alert-modal"
      footer={{
        primaryAction: {
          text: confirmButtonText,
          loading: isLoading,
          onClick: handleConfirmCheckout,
          disabled,
        },
        secondaryAction: {
          text: tt('Find another flight'),
          onClick: onCancel,
        },
      }}
    >
      <div css={fare_change_alert_card}>
        {fareChangeDetails.newFareComparisons && fareChangeDetails.newFareComparisons?.length !== 0 && (
          <FareRulesChange
            newFareComparison={fareChangeDetails.newFareComparisons[0]}
            isOutOfPolicy={isNewFareOutOfPolicy}
          />
        )}
        <FareBreakup fareChangeDetails={fareChangeDetails} />
      </div>

      {ruleInfos.length > 0 && (
        <>
          <Divider />
          <div css={fare_change_alert_card}>
            <PolicyContainer>
              {fareChangeDetails.isFareChangePositive && (
                <FareChangeNote>
                  {tt('Note that the increased trip amount does not meet your company policy:')}
                </FareChangeNote>
              )}
              <ViolatonsContainer>
                <PolicyViolations ruleInfos={ruleInfos} />
              </ViolatonsContainer>
            </PolicyContainer>
          </div>
        </>
      )}

      <ApprovalMessageContainer policyInfos={policyInfos} isVoidable={isVoidable ?? fareChangeDetails.isVoidable} />
    </Modal>
  );
};

export default FareChangeAlertModal;
